/**
 * Backlog Cull API
 *
 * Calls the AI backlog cull endpoints to generate and apply decisions
 * on stale tasks.
 */

import { fetchApi } from './fetch';

export interface CullTask {
  id: string;
  title: string;
  createdAt: string;
  daysSinceActivity: number;
  recommendation: 'keep' | 'delete' | 'defer';
  reasoning: string;
}

export interface GenerateResponse {
  tasks: CullTask[];
  totalStale: number;
  batchRemaining: number;
}

export interface Decision {
  taskId: string;
  action: 'keep' | 'delete' | 'defer';
  snoozeUntil?: string;
}

export interface ApplyRequest {
  decisions: Decision[];
}

export interface ApplyResponse {
  deleted: number;
  kept: number;
  deferred: number;
}

export async function generateCullBatch(opts?: {
  batchSize?: number;
  minAgeDays?: number;
}): Promise<GenerateResponse> {
  return fetchApi('/ai/backlog-cull/generate', {
    method: 'POST',
    body: JSON.stringify(opts ?? {}),
  });
}

export async function applyCullDecisions(decisions: Decision[]): Promise<ApplyResponse> {
  return fetchApi('/ai/backlog-cull/apply', {
    method: 'POST',
    body: JSON.stringify({ decisions } satisfies ApplyRequest),
  });
}
